/**
 * Base de ventas: lo que la pantalla dice de la base en uso y de cada versión, en palabras. Puro y testeado
 * (`base.test.ts`).
 */

import { num, plural } from "../../campana-nueva/utils/format";
import type { Version } from "../types";

export const R_SUBIR_BASE = "/activa/publico/subir";

/**
 * «2026-09-21T13:21» → «21/09». Es la hora de pared del comercio, como la escribió su sistema: no pasa por ningún
 * huso (con `new Date` una venta de las 23:30 se corría al día siguiente según dónde se mire).
 */
export function diaMes(isoLocal: string | null | undefined): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(isoLocal || ""));
  return m ? `${m[3]}/${m[2]}` : "";
}

/** «Ventas al 21/09 · hace 21 días». Los días los cuenta el servidor, en la hora del comercio. */
export function textoAntiguedad(hasta: string | null | undefined, dias: number | null): string {
  const dia = diaMes(hasta);
  if (!dia) return "La base no tiene ventas con fecha";
  if (dias === null) return `Ventas al ${dia}`;
  const cuando = dias <= 0 ? "hoy" : dias === 1 ? "ayer" : `hace ${num(dias)} días`;
  return `Ventas al ${dia} · ${cuando}`;
}

/** «22/09/2026 · 10:15»: cuándo se subió una versión, en la hora de quien mira. */
export function cuandoSubida(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const dos = (n: number) => String(n).padStart(2, "0");
  return `${dos(d.getDate())}/${dos(d.getMonth() + 1)}/${d.getFullYear()} · ${dos(d.getHours())}:${dos(d.getMinutes())}`;
}

/** «56.423 pedidos · 26.378 personas» */
export function tamanoVersion(v: Pick<Version, "pedidos" | "personas">): string {
  return `${num(v.pedidos)} ${plural(v.pedidos, "pedido", "pedidos")} · ${num(v.personas)} ${plural(v.personas, "persona", "personas")}`;
}

/** Quién la subió, para «subió …». */
export const quienSubio = (v: Pick<Version, "autor">) => v.autor.trim() || "el equipo";
